(function () {
    'use strict';

    angular
        .module('elogbooks.user.notifications')
        .controller('NotificationsListController', NotificationsListController);

    NotificationsListController.$inject = [
        '$state',
        '$stateParams',
        'notificationsCollectionResponse',
        'notificationsService',
        'lodash',
        '$translate',
        'apiClient',
        '$rootScope',
        'modulesService'
    ];

    function NotificationsListController (
        $state,
        $stateParams,
        notificationsCollectionResponse,
        notificationsService,
        lodash,
        $translate,
        apiClient,
        $rootScope,
        modulesService
    ) {
        var vm = this;
        vm.notifications = notificationsCollectionResponse.notifications;
        vm.notificationsCollectionResponse = notificationsCollectionResponse;
        vm.minDate = moment().add(-12, 'months').format('MM-DD-YYYY, 23:59:59');
        vm.auditsModuleEnabled = modulesService.isEnabled('audits_module');
        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');

        vm.criteria = {};

        const notificationsSelectedForRead = {};
        vm.notificationSelectedForRead = 0;
        vm.allAreMarkedForRead = false;
        vm.markAsReadLoading = false;
        vm.markAllAsReadDisabled = (() => {
            let isDisabled = true;

            for (let notification of vm.notifications) {
                if (notification.isRead === false) {
                    isDisabled = false;
                    break;
                }
            }

            return isDisabled;
        })();

        const disabledNotificationTypes = new Map([
            ["user_account_unlock_requested", "NOTIFICATION_NO_CONTENT"],
            ["password_reset_requested", "NOTIFICATION_NO_CONTENT"],
            ["password_reset_requested_on_behalf_of_user", "NOTIFICATION_NO_CONTENT"],
            ["password_reset_by_staff", "NOTIFICATION_NO_CONTENT"]
        ]);

        vm.notifications.forEach(notification => {
            if (disabledNotificationTypes.has(notification.type)) {
                notification.disabled = true;
                notification.tooltipMessage = disabledNotificationTypes.get(notification.type);
            }

            if (
                notification.type === "action_created" &&
                notification.summary.includes('Raised by Audit Question') &&
                !vm.auditsModuleEnabled
            ) {
                notification.title = notification.summary.replace(' - Raised by Audit Question', '');
            }
        });

        vm.notifications = vm.notifications.filter(notification =>
            !notification.type.includes('contract') || vm.contractsModuleEnabled
        );

        vm.getNotificationLink = (notification) => {
            return notificationsService.getNotificationLink(notification);
        }

        vm.onNotificationClick = (notification, $event) => {
            if (notification.disabled) {
                if ($event) {
                    $event.preventDefault();
                }
                return;
            }
            notificationsService.markAsRead(notification);
        }

        vm.criteria.typePatterns = {
            type: 'options',
            title: 'TYPE',
            multiple: true,
            value: $stateParams.typePatterns === undefined ? null : $stateParams.typePatterns,
            options: lodash.map(notificationsService.getTypeCategories(), c => ({
                title: $translate.instant(c.name),
                value: c.pattern.source
            }))
        };

        vm.criteria.readStatus = {
            type: 'options',
            title: 'NOTIFICATION_READ_STATUS',
            value: $stateParams.readStatus ? parseInt($stateParams.readStatus) : null,
            options: [
                {title: $translate.instant('NOTIFICATION_STATUS_ALL'), value: null},
                {title: $translate.instant('NOTIFICATION_STATUS_READ'), value: 1},
                {title: $translate.instant('NOTIFICATION_STATUS_UNREAD'), value: 2}
            ]
        };

        const createdAtData = (() => {
            const data = {
                defaultRangeOption: 3,
                options: [
                    {title: $translate.instant('LAST_ONE_MONTH'), value: 1},
                    {title: $translate.instant('LAST_THREE_MONTHS'), value: 3},
                    {title: $translate.instant('LAST_TWELVE_MONTHS'), value: 12},
                    {title: $translate.instant('CUSTOM'), value: 0}
                ]
            };

            const startDate = moment().subtract(data.defaultRangeOption, 'months').startOf('day');
            const endDate = moment().endOf('day');
            data.clearDateRangeValue = startDate.toISOString() + ',' + endDate.toISOString();

            return data;
        })();

        vm.criteria.dateRange = {
            type: 'date-time-range',
            title: 'CREATED_AT',
            startDateLabel: 'CREATED_AT_START_DATE',
            endDateLabel: 'CREATED_AT_END_DATE',
            value: $stateParams.dateRange ? $stateParams.dateRange : createdAtData.clearDateRangeValue,
            startDateRequired: true,
            endDateRequired: true,
            enableTime: false,
            options: createdAtData.options,
            defaultOption: createdAtData.defaultRangeOption,
            optionParam: 'createdAtRangeOption',
            clearValue: createdAtData.clearDateRangeValue,
            isClear: $stateParams.dateRange === createdAtData.clearDateRangeValue || $stateParams.dateRange === null,
            minDate: vm.minDate
        }

        vm.search = (params) => {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        };

        // Single notification checkbox - selects or remove notification for marking as read
        vm.toggleMarkAsRead = (notification) => {
            if (notification.isRead) {
                return;
            }

            if (notificationsSelectedForRead.hasOwnProperty(notification.id)) {
                delete notificationsSelectedForRead[notification.id];
                notification.markedForRead = false;
                vm.notificationSelectedForRead--;
            } else {
                notificationsSelectedForRead[notification.id] = notification;
                notification.markedForRead = true;
                vm.notificationSelectedForRead++;
            }

            if (vm.notificationSelectedForRead === 0) {
                vm.allAreMarkedForRead = false;
            }
        }

        // Checkbox on click toggle all notifications for read
        vm.markAllAsRead = () => {
            vm.allAreMarkedForRead = !vm.allAreMarkedForRead;

            for (let notification of vm.notifications) {
                let setAll = (!!!notification.markedForRead && vm.allAreMarkedForRead);
                let unsetAll = (!!notification.markedForRead && !vm.allAreMarkedForRead);

                if (setAll || unsetAll) {
                    vm.toggleMarkAsRead(notification);
                }
            }
        }

        // Button Mark As Read Click action
        vm.markSelectedAsRead = () => {
            if (vm.markAsReadLoading === true) {
                return;
            }

            const notificationsIds = Object.keys(notificationsSelectedForRead);

            if (notificationsIds.length === 0) {
                return;
            }

            vm.markAsReadLoading = true;

            const cloneNotificationsSelectedForRead = Object.assign({}, notificationsSelectedForRead);

            const resolve = () => {
                vm.markAsReadLoading = false;

                angular.forEach(notificationsSelectedForRead, (notification) => {
                    vm.toggleMarkAsRead(notification);
                    notification.isRead = true;
                });

                vm.markAllAsReadDisabled = (() => {
                    let isDisabled = true;

                    for (let notification of vm.notifications) {
                        if (notification.isRead === false) {
                            isDisabled = false;
                            break;
                        }
                    }

                    return isDisabled;
                })();

                $rootScope.$broadcast('NotificationsMarkedAsRead', cloneNotificationsSelectedForRead);
            };

            apiClient.update(notificationsCollectionResponse.getLink('markasread'), {
                notificationsIds
            }).then(resolve).catch(resolve);
        }
    }
})();
